import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar: false,  //是否顯示訊息列
    snackbarMsg: '',  //訊息列內容
    snackbarTheme: '',  //訊息列樣式
    // base_url:'http://www.pddtvgame.com:8080/badarapi/upload/thumb/',
    // base_url:'http://192.168.2.209/badarapi/upload/thumb/',
    // base_url: 'http://127.0.0.1/badarapi/upload/thumb/', //單機專用
    // base_url:'http://www.pddtvgame.com/badarapi/upload/thumb/',  //線上專用
    base_url:'http://www.corner-money.com/badarapi/upload/thumb/',  //user線上專用
    cData: {},  //暫存登入的廠商資料
    pData: {},  //暫存登入的使用者
    logined: false,  //登入情況->初設值為false
    time: '',  //現在時間
    usingData: [],  //目前使用中的資料
    loading: "",  //讀取介面顯示用,介面放在main.vue裡
    ver: '2023.11.15.1' //版本
  },
  mutations: {
    setUsingData(state, data) {  //設定正在使用的資料庫
      state.usingData = data;
    },
    getTime(state) {  //取得現在日期,時間
      var time = new Date();

      state.time = (
        time.getFullYear() +
        "-" +
        (time.getMonth() +
          1) +
        "-" +
        time.getDate() +
        " " +
        time.getHours() +
        ":" +
        time.getMinutes() +
        ":" +
        time.getSeconds()
      );
    },
    snackbar(state, val) {  //狀態列內容
      state.snackbarMsg = val.msg;
      state.snackbar = val.type;
      state.snackbarTheme = val.theme;
    },
    logined(state, val) {  //切換登入
      state.logined = val
    },
    setcData(state, val) {  //設定廠商資料
      state.cData = val
    },
    setpData(state, val) {  //設定登入者資料
      state.pData = val
    },
    setLoadingOn(state) {  //設定讀取畫面On
      state.loading = true
    },
    setLoadingOff(state) {  //設定讀取畫面Off
      state.loading = false
    },
  },
  getters: {
    // snackbar(state){
    //   return state.snackbar
    // }

  },
  actions: {
    // snackbar(context){
    //   context.commit('snackbar')
    // }
  },
  modules: {
  }
})
